import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=8c732104"
import script from "./BaseMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=8c732104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports